import './SessionExpiredPage.css';

import {useNavigate, useSearchParams} from "react-router-dom";

import { Button } from '../../../lib/components/buttons/Button';
import { IdentityService } from '../../../lib/infrastructure/identity/IdentityService';
import { SpaceBackgroundLayout } from '../../../lib/layouts/space-background/SpaceBackgroundLayout';
import { useMemo } from 'react';

export function SessionExpiredPage() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams ();

    // Where the user was when the session died. Absent, the literal "null" (what an un-guarded
    // template produces), or the expired page itself all fall back to the root — otherwise sign-in
    // would return them to a path that does not exist.
    const returnUrl = useMemo(() => {
        const url = searchParams.get("url");
        return url && url !== "null" && !url.includes("expired") ? url : "/";
    }, [searchParams]);
    
    return (
        <SpaceBackgroundLayout>

            <h1 className="logo-text">Orbital Watch</h1>

            <h1>Session Expired!</h1>
            <div><Button text={"Login"} type="primary" onClick={() => {
                  // Wipes the (possibly stale) MSAL cache but keeps the sign-in hints, so the address
                  // comes back pre-filled and the provider is already known.
                  IdentityService.clearIdentityStorage();
                  navigate(`/identity/login?url=${encodeURIComponent(returnUrl)}`);
            } } /></div>

        </SpaceBackgroundLayout>
    )
}
